/* eslint-disable */
import Vue from "vue";

export default {
  install() {
    Vue.prototype.$toastr = (type, text, title = null, position = 'bottom left') => {
      Vue.prototype.$notify({
        group: "ConveyNotification",
        type,
        text,
        title,
        position,
        closeOnClick: false,
      });
    };
  }
};
